import React, { useEffect, useMemo, useState } from "react";
import { Box, Typography, IconButton, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
  import { fetchallmapuserrole,overAllUsersSearch } from "../../../../services/apiService";
import AddGyanniUserRoleBase from "./AddGyanniUserRoleBase";
import Topbar from "../../../../scenes/global/Topbar";

const GyanniUserRole = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [loading, setLoading] = useState(false);

  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
 const [offset, setOffset] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [allUser, setAllUser] = useState([]);

  const [roleMappings, setRoleMappings] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [filterModel, setFilterModel] = useState({
    items: [],
  });

  const clientid = localStorage.getItem("clientId");
  const mstorgnhierarchytypeid = localStorage.getItem("organizationid");
  const [limit, setLimit] = useState(10);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);

  //     const totalRecordsParams = {
  //       clientid: Number(clientid),
  //       mstorgnhirarchyid: Number(mstorgnhierarchytypeid),
  //       limit: 100,
  //       offset: offset,
  //     };

  //     const initialData = await fetchallmapuserrole(totalRecordsParams);
  //     const total = initialData?.details?.total;

  //     setTotalRecords(total);
  //     const secondRequestParams = {
  //       clientid: Number(clientid),
  //       mstorgnhirarchyid: Number(mstorgnhierarchytypeid),
  //       limit: total,
  //       offset: offset,
  //     };

  //     try {
  //       const response = await fetchallmapuserrole(secondRequestParams);

  //       if (response.success && response.details?.values?.length) {
  //         const mappedData = response.details.values.map((item) => ({
  //           id: item.id,
  //           clientidname: item.clientidname,
  //           organizationname: item.organizationname,
  //           role: item.role,
  //           roleid: item.roleid,
  //           refusername: item.refusername,
  //         }));
  //         setRoleMappings(mappedData);
  //       } else {
  //         console.warn("No role mappings found.");
  //       }
  //     } catch (err) {
  //       console.error("Failed to fetch role mappings:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [clientid, mstorgnhierarchytypeid, page, pageSize]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
  
      try {
        const limit = pageSize;
        const offset = page * pageSize;
  
        const params = {
          clientid: Number(clientid),
          mstorgnhirarchyid: Number(mstorgnhierarchytypeid),
          limit,
          offset,
        };
  
        const response = await fetchallmapuserrole(params);
  
        if (response.success && Array.isArray(response.details?.values)) {
          const mappedData = response.details.values.map((item) => ({
            id: item.id,
            clientidname: item.clientidname,
            organizationname: item.organizationname,
            role: item.role,
            roleid: item.roleid,
            refusername: item.refusername,
          }));
  
          setRoleMappings(mappedData);
  
          // Set total records only if it exists in response
          if (typeof response.details.total === "number") {
            setTotalRecords(response.details.total);
          }
        } else {
          setRoleMappings([]);
          setTotalRecords(0);
          console.warn("No role mappings found.");
        }
      } catch (err) {
        console.error("Failed to fetch role mappings:", err);
        setRoleMappings([]);
        setTotalRecords(0);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [clientid, mstorgnhierarchytypeid, page, pageSize]);

  


  const openModal = () => {
    setIsModalOpen(true);
    // fetchClientNames(); // Call it when modal opens
  };

  const handleEdit = () => {
    console.log("Editing client:", currentRow);
  };

  const handleDelete = () => {
    console.log("Deleting client:", currentRow);
  };

  const columns = [
    { field: "clientidname", headerName: "Client Name", flex: 1 },
    { field: "organizationname", headerName: "Organization Name", flex: 1 },
    { field: "role", headerName: "Role", flex: 1 },
    { field: "refusername", headerName: "Ref User Name", flex: 1 },
    {
      field: "action",
      headerName: "Action",
      renderCell: ({ row }) => (
        <div style={{ display: "flex" }}>
          <IconButton
            onClick={() => handleEdit(row.original)}
            style={{ color: "#6870fa", fontSize: "12px" }}
          >
            <BorderColorIcon />
          </IconButton>
          <IconButton
            onClick={() => handleDelete(row.original)}
            style={{ color: "red", fontSize: "12px" }}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  const handleFilterChange = async (newFilterModel) => {
    console.log("handleFilterChange", newFilterModel);
    setFilterModel(newFilterModel);
    setLoading(true);
  
    try {
      if (!clientid || !mstorgnhierarchytypeid) {
        throw new Error("Missing clientid or mstorgnhierarchytypeid");
      }
  
      const filterValue = newFilterModel?.items?.[0]?.value || "";
  
      const totalParams = {
        search_string: filterValue,
      };
  
      console.log("totalParams==", totalParams);
  
      const initialData = await overAllUsersSearch(totalParams);
      const values = initialData?.details?.values || [];
  
      const formattedData = values.map((user) => ({
        id: user.id, // This is required for DataGrid
        branch: user.branch,
        clientname: user.clientname,
        firstname: user.firstname,
        lastname: user.lastname,
        loginname: user.loginname,
        password: user.password,
        mfaname: user.mfaname,
        name: user.name,
        orgname: user.orgname,
        useremail: user.useremail,
        usermobileno: user.usermobileno,
        usertype: user.usertype,
        vipuser: user.vipuser,
      }));
  
      setAllUser(formattedData);
      setTotalRecords(formattedData.length); // This must be a number
    } catch (err) {
      console.error("Error fetching filtered user data:", err);
      setAllUser([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      <div className="mt-4">
        <Topbar />
      </div>

      <Box m="20px" style={{ backgroundColor: colors.primary[400] }}>
        <div className="p-4 flex items-center justify-between">
          <h2 className="">Map User with Role</h2>
          <div
            style={{ backgroundColor: colors.blueAccent[500] }}
            className="text-white px-4 py-2 rounded-sm"
          >
            <button onClick={openModal} className="font-medium">
              {" "}
              <AddIcon /> Add
            </button>
          </div>
        </div>

        <Box
          m="0 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >


<DataGrid
  rows={roleMappings}
  columns={columns}
  pageSize={pageSize}
  page={page}
  rowCount={totalRecords}
  paginationMode="server"
  onPageChange={(newPage) => setPage(newPage)}
  onPageSizeChange={(newSize) => {
    setPageSize(newSize);
    setPage(0); 
  }}
  loading={loading}
  filterModel={filterModel}
  onFilterModelChange={handleFilterChange}
  rowsPerPageOptions={[5, 10, 20, 50]}
  pagination
/>

        </Box>

        <AddGyanniUserRoleBase
          isModalOpen={isModalOpen}
          closeModal={closeModal}
        />
      </Box>
    </>
  );
};

export default GyanniUserRole;
